/**
 * import react
 */
import React, { useState } from 'react';

/**
 * import material-ui
 */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummar from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import FiberManualRecord from '@material-ui/icons/FiberManualRecord';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

/**
 * import material-ui style and icons
 */
import makeStyles from '@material-ui/core/styles/makeStyles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

/**
 * import const
 */
import { constVal } from '../slot-const';

/**
 * import helper
 */
import { confDetailsJsonToObj, getSlotListUILogic, findNvrRecRtspUrl, findAanalyzeRtspUrl } from './helper';

const useStyles = makeStyles(() => ({
  slotNo: {
    width: '6%', textAlign: 'center'
  },
  mac: {
    width: '14%', textAlign: 'center'
  },
  brand: {
    width: '20%', textAlign: 'center'
  },
  model: {
    width: '20%', textAlign: 'center'
  },
  comment: {
    width: '35%', textAlign: 'center'
  },
  status: {
    width: '5%'
  },
  panelList: {
    borderTop: '1px solid #e0e0e0'
  }
}));

const SlotInformation = (props) => {
  const [dlg, setDlg] = useState({open: false});
  const classes = useStyles();

  const localConfInfo = props.basicInstall || {};
  const config_details = localConfInfo.config_details || '{}';
  const confDetailsObj = confDetailsJsonToObj(config_details);
  const { basic_installation={}, slot_configuration={} } = confDetailsObj;
  const {slots=[]} = slot_configuration;
  let {mapSlotList=[]} = getSlotListUILogic(slots);
  // mapSlotList = [];
  // eslint-disable-next-line react/prop-types
  const getPanelListItemDetails = (item) => {
    const panelDetailList = [{ key: 'Serial Number', val: item.cameraSN },
      { key: 'Firmware version', val: item.cameraFWVersion },
      { key: 'HW ID', val: item.cameraHWid },
      { key: 'Ip Adress', val: item.cameraIpAddr },
      { key: 'Profile EWC/Liveview/AI', val: item.cameraAnalyzeRtspPreferred },
      { key: 'Profile EWC/Liveview/AI Url', val: findAanalyzeRtspUrl(item)},
      { key: 'Profile NVR', val: item.cameraNvrRecRtspPreferred },
      { key: 'Profile NVR Url', val: findNvrRecRtspUrl(item)}]
    return (
      <ExpansionPanelDetails >
        <div style={{ width: '100%', border: '1px solid rgba(0, 0, 0, 0.12)', borderRadius: 4 }}>
          <Grid container>
            {panelDetailList.map(({ key = '', val = '' }, idx) => {
              return (
                <Grid item xs={12} key={idx}>
                  <Grid container>
                    <Grid item xs={3}>
                      <ListItem>
                        <ListItemText>{key}</ListItemText>
                      </ListItem>
                    </Grid>
                    <Grid item xs={9}>
                      <ListItem>
                        <ListItemText>{val ? `: ${val}` : ': -'}</ListItemText>
                      </ListItem>
                    </Grid>
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        </div>
      </ExpansionPanelDetails>
    );
  };

  const getTestedStatus = (cameraTestedStatus) => {
    let status;

    if (cameraTestedStatus === constVal.SUCCESS){
      status = <FiberManualRecord style={{ color: 'green' }} className={classes.status}/>
    }else {
      status = <FiberManualRecord style={{ color: 'red' }} className={classes.status}/>
    }

    return status;
  };

  // eslint-disable-next-line react/prop-types
  const getPanelListItemSummary = (val) => {
    const { cameraMAC = '-', cameraBrand = '-', cameraModel = '-', cameraComment = '-', slotNo = '', cameraTestedStatus = '' } = val || {};
    const panelList = [{ txt: slotNo, className: classes.slotNo },
      { txt: cameraMAC, className: classes.mac },
      { txt: cameraBrand, className: classes.brand },
      { txt: cameraModel, className: classes.model },
      { txt: cameraComment, className: classes.comment }];
    return (
      <ExpansionPanelSummar expandIcon={<ExpandMoreIcon />}>
        {panelList.map(({ txt = '', className = {} }, idx) => {
          return (
            <Typography key={idx} className={className} noWrap>{txt || '-'}</Typography>
          );
        })}
        {getTestedStatus(cameraTestedStatus)}
      </ExpansionPanelSummar>
    );
  };

  const getPanelListItem = () => {
    return (
      mapSlotList.map((val, idx) => {
        return (
          <ExpansionPanel key={idx} className={classes.panelList}>
            {getPanelListItemSummary(val)}
            {getPanelListItemDetails(val)}
          </ExpansionPanel>
        );
      })
    );
  };

  const getPanelHeader = () => {
    const hdrPanelList = [{ hdrTxt: 'Slot No', className: classes.slotNo },
      { hdrTxt: 'MAC', className: classes.mac },
      { hdrTxt: 'Brand', className: classes.brand },
      { hdrTxt: 'Model', className: classes.model },
      { hdrTxt: 'Label', className: classes.comment },
      { hdrTxt: 'Status', className: classes.status }];

    return (
      <ExpansionPanel disabled>
        <ExpansionPanelSummar expandIcon={<ExpandMoreIcon />}>
          {hdrPanelList.map(({ hdrTxt = '', className = {} }, idx) => {
            return (
              <Typography key={idx} className={className}>{hdrTxt}</Typography>
            );
          })}
        </ExpansionPanelSummar>
      </ExpansionPanel>
    );
  };

  const panelList = () => {
    return (
      <>
        {getPanelHeader()}
        {getPanelListItem()}
      </>
    );
  };

  const contentDlg = () => {
    if (mapSlotList.length) {
      return panelList();
    } else {
      return (
        <Typography align='center'>Slots are not associated to camera</Typography>
      );
    }
  };

  const openDlg = () => {
    const styleObj = mapSlotList.length ? { backgroundColor: '#efefef' } : {};
    return (
      <>
        <Dialog open={true} maxWidth='lg'>
          <DialogTitle>Slot Information</DialogTitle>
          <DialogContent style={styleObj}>
            {contentDlg()}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDlg(() => ({open: false}))}>Close</Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };

  const content = () => {
    const { install_progress_step=0} = basic_installation;
    if (install_progress_step == constVal.ENCHANCED_INSTALL || install_progress_step > constVal.BASIC_INSTALL_VEIRY_COMPLETE) {
      return (
        <>
          <Button onClick={() => setDlg(() => ({open: true}))}>Slot Information</Button>
          {dlg.open ? openDlg() : null }
        </>
      );
    } else {
      return null;
    }
  };

  return (
    <>
    {content()}
    </>
  );
};

export default SlotInformation;
